import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserHelper } from '@helpers/user.helper';
import { DataHelper } from '@helpers/data.helper';
import { UiHelper } from '@helpers/ui.helper';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'quick-tipp',
  templateUrl: '../sharedTemplates/quick-tipp.html',
})
export class QuickTipp implements AfterViewInit, OnDestroy {
  @Output() closeQuickTippOutput = new EventEmitter();

  private subscriptionsToStopOnDestroy: Subscription[] = [];
  public currentSlipList = [];
  slipsList = [];
  placeBetIsActive = false;
  currentSlipListLength = 0;
  amountPerBet = 0;
  stakePerBet = 0;
  numberOfBets = 0;
  maxGain = 0;
  totalRate = 0;
  minGain = 0;
  systemItems = [];
  currentSlipTabSelected = 1;
  totalStakeKeyboard = '';
  toPay = 0;
  toPayNumeric = 0;
  tax = '';
  error_oddrefresherror = false;
  keyboardIsOpen = false;
  stakeString = '';
  today = new Date();

  constructor(
    public _UserHelper: UserHelper,
    public _DataHelper: DataHelper,
    public _UiHelper: UiHelper,
    private _ApiService: ApiService,
    private _changeDetection: ChangeDetectorRef,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    public dialog: MatDialog
  ) {}

  ngAfterViewInit() {
    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.currentSlipDataListener.subscribe(x => {
        this.getCurrentSlip(x);
      })
    );
    this.subscriptionsToStopOnDestroy.push(
      this._DataHelper.numberOfBetsListener.subscribe(x => {
        this.currentSlipListLength = x;
      })
    );
  }

  ngOnDestroy() {
    this.placeBetIsActive = false;
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }

  closeQuickTipp() {
    this.closeQuickTippOutput.emit(true);
  }

  placeBetStatus(value) {
    this._DataHelper.ChangeOddIsActive = !value;
    this.placeBetIsActive = value;
  }

  openRightMenu() {
    this._UiHelper.b3000SetRightMenuState('open');
  }

  removeOdd(oddId) {
    this.placeBetIsActive = false;
    this._ApiService.currentSlipRemoveOdd(oddId);

    if (this.currentSlipList.length <= 1) {
      this._DataHelper.ChangeOddIsActive = true;
    }
  }

  goEventDetail(e) {
    if (this._DataHelper.liveData) {
      const match = this._DataHelper.liveData.find(m => m.EventId === e.MatchId);
      if (match === undefined) {
        this._router.navigate(['/eventdetail', e.MatchId]);
      } else {
        this._router.navigate(['/liveeventdetail', e.MatchId]);
      }
    }
  }

  getLiveEvent(e) {
    if (this._DataHelper.liveData) {
      const match = this._DataHelper.liveData.find(m => m.EventId === e);
      return match;
    } else {
      // this.currentSlipListLength = 0;
    }
  }

  getCurrentSlip(x) {
    this.currentSlipList = x;
    this.currentSlipListLength = x.length;
    this.getCurrentSlipAmount();
    // Live Odds Control
    const visibilityindex = this.currentSlipList.findIndex(v => {
      return v.Visibility === 'hidden';
    });

    if (visibilityindex > -1) {
      this.error_oddrefresherror = true;
    } else {
      this.error_oddrefresherror = false;
    }
  }

  getCurrentSlipAmount() {
    let systemValues = '';
    this.systemItems.forEach(cb => {
      if (cb.selected) {
        systemValues += '1,';
      } else {
        systemValues += '0,';
      }
    });
    if (systemValues !== '') {
      systemValues = systemValues.substring(0, systemValues.length - 1);
    }

    if (this._DataHelper.taxRate !== 0) {
      this.toPayNumeric = (this._DataHelper.currentSlipInfo.currentslip_totalStake * 100) / (100 + this._DataHelper.taxRate);
      this.tax = (this._DataHelper.currentSlipInfo.currentslip_totalStake - this.toPay).toFixed(4);
    } else {
      this.toPay = this._DataHelper.currentSlipInfo.currentslip_totalStake;
      this.toPayNumeric = this.toPay;
    }

    this._ApiService.getCurrentSlipAmount(this.toPayNumeric, this.currentSlipTabSelected, systemValues).then(calc => {
      if (calc != null) {
        let result = {
          AmountPerBet: 0,
          NumberOfBets: 0,
          ToPay: 0,
          MaxGain: 0,
          MinGain: 0,
          TotalRate: 0,
        };
        if (calc.length > 0) {
          result = calc[0];
        }

        this.amountPerBet = result.AmountPerBet;
        this.numberOfBets = result.NumberOfBets;
        this.toPay = result.ToPay;
        this.maxGain = result.MaxGain;
        this.minGain = result.MinGain;
        this.totalRate = result.TotalRate;
        this._DataHelper.currentSlipInfo.currentTotalRate = result.TotalRate;
        this._DataHelper.currentSlipOpened = true;
        this._changeDetection.detectChanges();
      }
    });
  }

  changeKeyboardState(value: boolean) {
    this.keyboardIsOpen = value;
    this.getCurrentSlipAmount();
  }

  changeStakeInKeyboardB3000(e, option = '') {
    if (option === '') {
      this.stakeString += e;
    } else if (option === 'backspace') {
      this.stakeString = this.stakeString.slice(0, -1);
    } else if (option === '+10') {
      this.stakeString = (Number(this.stakeString) + 10).toString();
    } else if (option === '+50') {
      this.stakeString = (Number(this.stakeString) + 50).toString();
    } else if (option === 'C') {
      this.stakeString = '0';
    }

    this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(this.stakeString);

    if (this._UserHelper !== undefined) {
      if (this._UserHelper.customerUser !== undefined) {
        if (this._UserHelper.customerUser.Symbol === 'IQD' || this._UserHelper.customerUser.Symbol === 'IRR') {
          this._DataHelper.currentSlipInfo.currentslip_totalStake = Number(e) * 1000;
        }
      }
    }
  }

  placeBet() {
    if (this._UserHelper.isSignedIn) {
      // this._UiHelper.setLoadingDialog(true);
      this._UiHelper.setLoadingTicketDialog(true);

      const systemValues = '';
      this.apiPlaceBet(systemValues);
    } else {
      const translator = new TranslatePipe(this._LocalizationService);
      const t_message = translator.transform('errorcode5', null);
      this._UiHelper.errorSnackBar(t_message, '');
    }
  }

  apiPlaceBet(systemValues) {
    this._UiHelper.flagRefreshCurrentSlip = false;
    const translator = new TranslatePipe(this._LocalizationService);
    this._ApiService
      .placeBet(this.toPayNumeric, 0, systemValues)
      .then(data => {
        if (data.body === '') {
          this._UiHelper.flagRefreshCurrentSlip = true;
          return 'error|System Error';
        } else {
          if (data.body.split('|')[0] === 'error') {
            this._UiHelper.flagRefreshCurrentSlip = true;
            this._UiHelper.errorSnackBar(data.body.split('|')[1], '');
          } else if (data.body.split('|')[0] === 'errorcode') {
            const t_message = translator.transform(data.body.split('|')[1], null);

            this._UiHelper.errorSnackBar(t_message, '');
            this._UiHelper.flagRefreshCurrentSlip = true;
          } else if (data.body.split('|')[0] === 'success') {
            this._ApiService.clearCurrentSlip();

            this._DataHelper.ChangeOddIsActive = true;
            this.placeBetIsActive = false;
            this.currentSlipListLength = 0;
            this._ApiService.getSlips(new Date().getMonth(), new Date().getFullYear(), 1).then(x => {
              this.slipsList = [];
              if (x !== undefined && x.length > 0) {
                this.slipsList.push(x[0]);
              }
            });
            const t_message = translator.transform('successcode2', null);
            this._UiHelper.successSnackBar(t_message, '');
            this._ApiService.getSelectedOdds();
            this._ApiService
              .getClient()
              .then(result => {
                this._UserHelper.setUser(result);
                this._UiHelper.flagRefreshCurrentSlip = true;
              })
              .catch();
          } else {
            this._UiHelper.flagRefreshCurrentSlip = true;
            const t_message_err = translator.transform('errorcode3', null);
            this._UiHelper.errorSnackBar(t_message_err, '');
          }
        }
      })
      .catch(err => console.log('quick-tipp', err))
      .finally(() => this._UiHelper.setLoadingDialog(false));
  }
}
